import { CheckCircleIcon, CircleNotchIcon, InfoIcon, WarningCircleIcon, WarningIcon } from "@phosphor-icons/react"
import { Toaster as Sonner } from "sonner"
import { useIsMobile } from "@/hooks/use-mobile"
import { themeMode, useTheme } from "@/modules/theme"

type ToasterProps = React.ComponentProps<typeof Sonner>

const AppToaster = ({ ...props }: ToasterProps) => {
  const isMobile = useIsMobile()
  const mode = themeMode(useTheme())

  return (
    <Sonner
      theme={mode}
      position={isMobile ? "bottom-center" : "bottom-right"}
      mobileOffset={{ bottom: "16px", left: "16px", right: "16px" }}
      duration={4000}
      expand
      className="group"
      // On the toast layer, over tours; a style, as Sonner's own z-index rule would win over a class
      style={{ zIndex: 'var(--lureo-layer-toast)', '--width': '18rem' } as React.CSSProperties}
      icons={{
        success: <CheckCircleIcon className="size-5 text-lureo-brand-ink" />,
        error: <WarningCircleIcon className="size-5 text-lureo-danger-ink" />,
        warning: <WarningIcon className="size-5 text-lureo-warning-ink" />,
        info: <InfoIcon className="size-5 text-lureo-brand-ink" />,
        loading: <CircleNotchIcon className="size-5 animate-spin text-lureo-brand-ink" />,
      }}
      toastOptions={{
        classNames: {
          icon: "size-5",
          toast:
            "group toast font-lureo-font-ui group-data-[sonner-toaster]:bg-lureo-surface group-data-[sonner-toaster]:text-lureo-ink-strong group-data-[sonner-toaster]:border-0 group-data-[sonner-toaster]:shadow-lureo-shadow-overlay group-data-[sonner-toaster]:rounded-lureo-radius group-data-[sonner-toaster]:min-h-18",
          description: "group-[.toast]:text-lureo-ink-subtle",
          actionButton:
            "group-[.toast]:bg-lureo-brand group-[.toast]:text-lureo-on-brand",
          cancelButton:
            "group-[.toast]:bg-lureo-brand-ink/20 group-[.toast]:text-lureo-brand-ink",
        },
      }}
      {...props}
    />
  )
}

export { AppToaster }
